var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 22.8813C18.8794 22.8813 23.5347 18.2261 23.5347 12.5967C23.5347 6.95703 18.8794 2.31201 13.2397 2.31201C7.61035 2.31201 2.96533 6.95703 2.96533 12.5967C2.96533 18.2261 7.62061 22.8813 13.25 22.8813ZM13.25 21.5483C8.28711 21.5483 4.29834 17.5493 4.29834 12.5967C4.29834 7.63379 8.28711 3.63477 13.2397 3.63477C18.2026 3.63477 22.2017 7.63379 22.2119 12.5967C22.2119 17.5493 18.2129 21.5483 13.25 21.5483ZM9.67139 16.8315C9.85596 16.8315 10.0098 16.7598 10.1431 16.6265L13.2397 13.5195L16.3569 16.6265C16.4902 16.7598 16.644 16.8315 16.8286 16.8315C17.1875 16.8315 17.4746 16.5444 17.4746 16.1855C17.4746 16.001 17.4028 15.8574 17.2695 15.7241L14.1523 12.6069L17.2798 9.47949C17.4233 9.33594 17.4746 9.20264 17.4746 9.01807C17.4746 8.66943 17.1875 8.38232 16.8286 8.38232C16.6646 8.38232 16.521 8.44385 16.3774 8.59766L13.2397 11.7046L10.1328 8.59766C9.99951 8.46436 9.85596 8.40283 9.67139 8.40283C9.3125 8.40283 9.02539 8.66943 9.02539 9.02832C9.02539 9.20264 9.08691 9.35645 9.22021 9.48975L12.3374 12.6069L9.22021 15.7344C9.08691 15.8574 9.02539 16.0112 9.02539 16.1855C9.02539 16.5444 9.3125 16.8315 9.67139 16.8315Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclex);
export default __webpack_public_path__ + "static/media/Circle x.435ac9810ee4e268b4177634553070e5.svg";
export { ForwardRef as ReactComponent };